import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === undefined)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  // Signed-out visitors land on the homepage (video + services) and return here after signing in.
  if (!user) return <Navigate to={`/?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  return children;
}
